import store from '@/store';
import { normalizeUiLocale } from '@/locales/language'

const KEFU_LOCALES = {
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-HK',
  en: 'en-US',
  Vietnamese: 'vi-VN'
}

export function getKefuLanguage(locale = localStorage.getItem('language')) {
  const normalizedLocale = normalizeUiLocale(locale)
  return KEFU_LOCALES[normalizedLocale] || KEFU_LOCALES['zh-CN']
}

export function initKefu (locale) {
  if (window.ssq) {
    window.ssq.push('clearUser');
    const userInfo = store.state.userInfo
    window.ssq.push('setLoginInfo', {
      user_id: userInfo.id, // 加密后的用户id, 必填！
      user_name: userInfo.realname, // 对应用户名
      language: getKefuLanguage(locale), // 对应用户语言
    })
  } else {
    console.error("ssq is not defined or not loaded yet.");
  }
}
export function getCurrentDay() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;  // 返回格式如 2025-06-07
}

export function formatDate(timestamp, type = 'day') {
  if (!timestamp) return '';

  // 如果是秒级时间戳（10 位），乘 1000 转成毫秒
  if (timestamp.toString().length === 10) {
    timestamp = timestamp * 1000;
  }

  const date = new Date(timestamp);
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const vietnam = new Date(utc + 7 * 60 * 60000);

  const y = vietnam.getFullYear();
  const m = ('0' + (vietnam.getMonth() + 1)).slice(-2);
  const d = ('0' + vietnam.getDate()).slice(-2);
  const h = ('0' + vietnam.getHours()).slice(-2);
  const min = ('0' + vietnam.getMinutes()).slice(-2);
  const s = ('0' + vietnam.getSeconds()).slice(-2);

  if(type === 'day') {
    return `${y}-${m}-${d}`;
  }else {
    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }
}
export function translateText(arr) {

  return new Promise((resolve, reject) => {
    // console.log(localStorage.getItem("language") === 'zh-CN')
    // if(localStorage.getItem("language") === 'zh-CN') {
      resolve(arr);
    // }else {
    //   translate.request.translateText({
    //     from: 'chinese_simplified',  // 中文
    //     to: 'vietnamese',            // 越南
    //     texts: arr
    //   }, function(data){
    //     resolve(data.text)
    //   }, function(err){
    //     resolve(arr)
    //   });
    // }

  })
}

//  兼容pc端rem
export function setRem() {
  const DESIGN_WIDTH = 1920; // 设计稿宽度
  const MAX_WIDTH = 512;     // PC 最大宽度

  let screenWidth = document.documentElement.clientWidth;

  // 如果屏幕大于 512px，则按照最大宽度计算
  if (screenWidth > MAX_WIDTH) screenWidth = MAX_WIDTH;

  // 设置 html 的 font-size
  document.documentElement.style.fontSize = screenWidth / 10 + 'px';
}
// 判断是否为移动端
export function isMobile() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // 移动端常见关键字
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}



// WEBPACK FOOTER //
// ./src/common/utils.js